import { makeStyles, Theme } from '@material-ui/core/styles';
import styled from 'styled-components';
import Colors from "modules/Colors";

const useStyles = makeStyles((_theme: Theme) => ({
  tableContainer: {
    borderRadius: 6,
    maxHeight: 458,
  },
  tableHead: {
    color: Colors.greyDark,
  },
  withBorderBottom: {
    borderBottom: "1px solid #c8c7cc",
  },
  noBorderBottom: {
    borderBottom: "none",
  },
  downloadInvoiceButton: {
    textTransform: "none",
    borderRadius: 48,
    backgroundColor: "white",
    color: Colors.purple,
    shadowBox: "none",
    "&:hover": {
      backgroundColor: "white",
      color: Colors.purple,
    },
  },
}))

export interface IconProps {
  margin?: string
}

interface ArrowImageContainerProps {
  width?: string
}

interface SupportButtonContainerProps {
  marginTop?: string
}

export const StyledNavBar = styled.nav`
  display: flex;
  flex-direction: row;
  align-items: center;
  border-bottom-width: 1px;
  margin-bottom: 32px;
  border-color: rgba(209, 213, 219, 1);
  flex-grow: 1;
  margin-top: 32px;
`

export const StyledSpan = styled.span`
  color: ${({ color }: any) => color};
`

export const UnorderedList = styled.ul`
  list-style: none;
`

export const ListItem = styled.li`
  padding-left: 16px;
  color: #707070;
  &::before {
    content: "\u2022";
    color: #707070;
    font-weight: bold;
    display: inline-block;
    width: 1em;
    margin-left: -1em;
  }
`

export const Icon = styled.img`
  margin: ${({ margin }: IconProps) => margin};
`

export const ArrowImageContainer = styled.div`
  display: flex;
  justify-content: center;
  padding: 12px auto 26px auto;
  background-color: rgba(136, 0, 255, 0.24);
  width: ${({ width }: ArrowImageContainerProps) => width};
  border-radius: 12px;
`

export default useStyles
